import { useMemo } from "react";

import { getFulfillmentPriorityAccess } from "../shared/FulfillmentPriority";
import { permissions } from "../shared/Permissions";
import { useAuth } from "./auth";

export function useFulfillmentPriorityAccess() {
  const { hasPermission, isUnitedStates } = useAuth();
  const { edit, view } = permissions.settings.fulfillmentPriority;
  const hasEditPermission = hasPermission(edit);
  const hasViewPermission = hasPermission(view);

  return useMemo(
    () =>
      getFulfillmentPriorityAccess({
        hasEditPermission,
        hasViewPermission,
        isUnitedStates,
      }),
    [hasEditPermission, hasViewPermission, isUnitedStates],
  );
}
